<template>
	<PrimePopover
		ref="primePopoverRef"
		v-bind="$attrs"
		:pt="passThrough"
		class="meridia-popover"
		unstyled
		@show="$emit('show')"
		@hide="$emit('hide')"
	>
		<slot />
	</PrimePopover>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import PrimePopover from 'primevue/popover';
import { usePassThrough } from 'primevue/passthrough';
import { PassThrough } from '@primevue/core';
import { PopoverPassThroughOptions } from 'primevue';
import { MeridiaPopoverPassThrough } from 'src/design_system/components/popover/types';

const props = defineProps<{
	pt?: MeridiaPopoverPassThrough;
}>();

const primePopoverRef = ref<InstanceType<typeof PrimePopover> | null>(null);

const passThrough = (usePassThrough(
	props.pt,
	{
		root: {
			class:
				'!p-0',
		},
		content: {
			class: 'p-s',
		},
	} as PopoverPassThroughOptions,
	{ mergeSections: false, mergeProps: true }
) ?? {}) as PassThrough<PopoverPassThroughOptions>;

function toggle(event: MouseEvent) {
	primePopoverRef.value?.toggle(event);
}
function show(event: MouseEvent) {
	primePopoverRef.value?.show(event);
}
function hide() {
	primePopoverRef.value?.hide();
}

defineExpose({ toggle, show, hide });
</script>

<style src="src/design_system/components/popover/popover.scss"></style>